import server from "@/public/service"
import {SUCCESS_CODE} from "@/public/state";

var storage = window.localStorage;
var sessionStorage = window.sessionStorage;
export default function(){
    let token = storage.getItem("token");
    
    if(!token){
        storage.removeItem("token");
        sessionStorage.removeItem("token");
        this.$store.state.userInfo = {};
        this.$store.state.loginAfterRoute = undefined;
        this.$router.replace("/login");
        this.$message({
            type:"success",
            message:"退出成功",
            showClose: true
        });
    }else{
        // this.$store.hiddenMenu = true;
        server.logout({token}).then(data=>{
            if(data.reCode === SUCCESS_CODE){
                storage.removeItem("token");
                sessionStorage.removeItem("token"); 
                this.$store.state.userInfo = {};
                this.$store.state.loginAfterRoute = undefined; 
                this.$router.replace("/login"); 
                this.$message({
                    type:"success",
                    message:"退出成功",
                    showClose: true
                });
            }
        })
    };

}